import {
  assetSubtypesSearchSchema,
  assetSubtypesViewColumns,
  mapAssetSubtypesViewQuery,
} from "./AssetSubtypesView.default";
import ManagedGridView from "../controls/ManagedGridView";
import { SearchQuery } from "../code/search-query/search-query";
import { getAssetSubtypes } from "../repository/data.repository";
import { createGridRequest } from "../hooks/useGridRequest";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";

export interface AssetSubtypesViewProps {
  readonly trigger?: string;
  readonly onAction?: (key: string, record: any) => void;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

function AssetSubtypesView(props: AssetSubtypesViewProps) {
  const permissions = useSelector(authorizeSelectors.permissions);

  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={assetSubtypesViewColumns}
      schema={assetSubtypesSearchSchema}
      mapQuery={mapAssetSubtypesViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getAssetSubtypes, { retry: true })}
      pageSize={100}
      actions={[
        {
          key: "update",
          label: "Edit",
          disabled: !permissions.can("AssetSubtypes", "edit"),
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "delete",
          label: "Delete",
          danger: true,
          disabled: !permissions.can("AssetSubtypes", "delete"),
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default AssetSubtypesView;
